import React from 'react';
import { Stack, Text, Box, List } from '@mantine/core';
import { ProjectExperience } from '../models/projectExperience.model';

interface ProjectExperienceDetailsProps {
  project: ProjectExperience;
}

export function ProjectExperienceDetails({ project }: ProjectExperienceDetailsProps) {
  // Split responsibilities by newlines for display
  const responsibilitiesList = project.responsibilities 
    ? project.responsibilities.split('\n').filter(r => r.trim() !== '')
    : [];

  return (
    <Stack gap="sm" mt="sm">
      {project.info?.description && (
        <Box>
          <Text size="sm" fw={500} mb="xs">Description:</Text>
          <Text size="sm" style={{ whiteSpace: 'pre-wrap' }}>
            {project.info.description}
          </Text>
        </Box>
      )}
      
      {responsibilitiesList.length > 0 && (
        <Box>
          <Text size="sm" fw={500} mb="xs">Responsibilities:</Text>
          {responsibilitiesList.length === 1 ? (
            <Text size="sm">{responsibilitiesList[0]}</Text>
          ) : (
            <List size="sm" spacing="xs">
              {responsibilitiesList.map((responsibility, index) => (
                <List.Item key={index}>{responsibility}</List.Item>
              ))}
            </List>
          )}
        </Box>
      )}
    </Stack>
  );
} 